<template>
    <div>
        <div class="alert alert-warning" role="alert" v-if="isRecurring">
            <i class="famfamfam-silk arrow_refresh"></i>
            This is a recurring appointment
        </div>
        <form class="form-horizontal pl-1">
            <div v-if="data.appointmentType" class="form-group row">
                <label class="col-sm-3 col-form-label">Type:</label>
                <div
                    v-if="data.appointmentType"
                    class="col-sm-9 col-form-label"
                >
                    {{ data.appointmentType.type }}
                </div>
            </div>
            <div
                v-if="triageObjectDisplay && data.status == 1"
                class="form-group row"
            >
                <label class="col-sm-3 col-form-label">Triage:</label>
                <div class="col-sm-9 col-form-label">
                    <div v-if="isLoadingTriage">Loading...</div>
                    <div v-else>
                        <div
                            v-if="isEditTriage"
                            class="d-flex align-items-center"
                        >
                            <select
                                id="triage_id"
                                v-model="triageSelected"
                                class="form-control"
                                name="triage_id"
                            >
                                <option
                                    v-for="triage in triageOptions"
                                    :key="triage.id"
                                    :value="triage.id"
                                    >{{ triage.triage }}</option
                                >
                            </select>
                            <i
                                @click="updateTriage()"
                                class="fas fa-check btn-inline-edit"
                            />
                        </div>
                        <div v-else>
                            <span
                                :style="setTriageStyle(triageObjectDisplay)"
                                class="triage-badge"
                                >{{
                                    triageObjectDisplay.active_triage_type
                                        .triage
                                }}</span
                            >
                            <i
                                @click="editTriage()"
                                class="fas fa-pen btn-inline-edit secondary"
                            ></i>
                        </div>
                    </div>
                </div>
            </div>
            <div v-if="data.reason" class="form-group row">
                <label class="col-sm-3 col-form-label">Complaint:</label>
                <div class="col-sm-9 col-form-label">{{ data.reason }}</div>
            </div>
            <div
                v-if="data.status == 0 || data.status == 8"
                class="form-group row"
            >
                <label class="col-sm-3 col-form-label">Assign To:</label>
                <div
                    v-html="getAssignTo(data)"
                    class="col-sm-9 col-form-label"
                ></div>
            </div>
            <div v-if="data.status > 0" class="form-group row">
                <label class="col-sm-3 col-form-label">Provider:</label>
                <div class="col-sm-9 col-form-label">
                    <span v-if="data.provider">{{ data.provider.label }}</span>
                    <span v-else-if="data.default_provider">{{
                        data.default_provider.label
                    }}</span>
                </div>
            </div>
            <div v-if="data.type == 0" class="form-group row">
                <label class="col-sm-3 col-form-label">Status:</label>
                <div class="col-sm-9 col-form-label">
                    <i
                        :class="statusClass(data.appointmentStatus.id)"
                        class="famfamfam-silk"
                        style="margin-right: 1% !important;"
                    ></i>
                    <a
                        v-if="statusAccess && !_isTvView"
                        @click.prevent="statusClick"
                        href="#"
                        >{{ data.appointmentStatus.value }}</a
                    >
                    <span v-else href="#">{{
                        data.appointmentStatus.value
                    }}</span>
                </div>
            </div>
            <div v-if="data.client" class="form-group row">
                <label class="col-sm-3 col-form-label">Client:</label>
                <div v-if="data.client" class="col pt-2">
                    <router-link
                        v-if="
                            data.client.single_business_actor &&
                            data.client.single_business_actor.isactive &&
                            USE_CLIENT_MODULE_VUE
                        "
                        :to="`/client/profile/${data.client.encoded_id}`"
                    >
                        {{ data.client.firstname }}
                        {{ data.client.lastname }}
                    </router-link>
                    <a
                        v-else-if="
                            data.client.single_business_actor &&
                            data.client.single_business_actor.isactive
                        "
                        :href="data.client.ci_url"
                    >
                        {{ data.client.firstname }}
                        {{ data.client.lastname }}
                    </a>
                    <span v-else>
                        {{ data.client.firstname }}
                        {{ data.client.lastname }} (deleted)
                    </span>
                    <span v-if="data.client.mobile">
                        (M:
                        <a
                            :href="
                                'tel:' +
                                data.client.mobile_country_code +
                                ' ' +
                                data.client.mobile
                            "
                            >{{ data.client.mobile }}</a
                        >)
                    </span>
                    <span v-else-if="data.client.home">
                        (H:
                        <a
                            :href="
                                'tel:' +
                                data.client.home_country_code +
                                ' ' +
                                data.client.home
                            "
                            >{{ data.client.home }}</a
                        >)
                    </span>
                </div>
            </div>
            <div v-if="_.some(data.patient)" class="form-group row">
                <label class="col-sm-3 col-form-label">Patient:</label>
                <div class="col-sm-9 col-form-label patient-row">
                    <div>
                        <span
                            v-if="
                                data.patient.single_business_patient &&
                                data.patient.single_business_patient.isactive ==
                                    1
                            "
                        >
                            <router-link
                                :to="`/patient/profile/${data.patient.encoded_id}`"
                            >
                                {{ data.patient.name }}
                            </router-link>
                        </span>
                        <span v-else> {{ data.patient.name }} (Inactive) </span>
                        <span>{{ getPatientBreed(data) }}</span>
                    </div>
                    <summarize-button
                        v-if="isSummarizerEnabled"
                        small
                        @click="openSummarizePatient"
                    />
                </div>
            </div>
            <div class="form-group row">
                <label class="col-sm-3 col-form-label">Location:</label>
                <div
                    v-html="getAppointmentLocation(data)"
                    class="col-sm-9 col-form-label"
                ></div>
            </div>
            <div v-if="data.type == 0" class="form-group row">
                <label class="col-sm-3 col-form-label">Address:</label>
                <div
                    v-html="getAppointmentAddress(data)"
                    class="col-sm-9 col-form-label"
                ></div>
            </div>
            <div v-if="data.client" class="form-group row">
                <label class="col-sm-3 col-form-label">Referred By:</label>
                <div
                    v-if="data.referral && data.referralSubject"
                    class="col-sm-8 col-form-label"
                >
                    <a
                        :href="data.referral.ci_url"
                        v-if="data.referralSubject.label"
                        >{{ data.referralSubject.label }}</a
                    >
                    <a
                        :href="data.referral.ci_url"
                        v-else-if="data.referralSubject.name"
                        >{{ data.referralSubject.name }}</a
                    >
                    <span v-else-if="data.referralSubject.title">
                        {{ data.referralSubject.title }}
                        <span v-if="!data.referralSubject.isactive"
                            >(deleted)</span
                        >
                    </span>
                </div>
            </div>
            <div class="form-group row">
                <label class="col-sm-3 col-form-label">Notes:</label>
                <div
                    class="col-sm-9 col-form-label"
                    v-html="replaceNewLine(data.note)"
                ></div>
            </div>
            <div v-if="canShowMedicalNoteField" class="form-group row">
                <label class="col-sm-3 col-form-label"
                    >Medical&nbsp;Note:</label
                >
                <div class="col-sm col-form-label">
                    <div v-if="isLoadingMedicalNote">
                        Loading...
                    </div>
                    <div v-else>
                        <div v-if="isEditMedicalNote">
                            <div class="d-flex align-items-start">
                                <div class="w-100">
                                    <select
                                        id="medical-note-option"
                                        class="form-control"
                                        v-model="medicalNoteSelected"
                                    >
                                        <option
                                            v-for="option in medicalNoteOptions"
                                            :value="option.id"
                                            :key="option.id"
                                            >{{ option.label }}
                                        </option>
                                    </select>
                                    <select
                                        id="medical-note-template-option"
                                        class="form-control mt-2"
                                        v-if="isSelectingNewMedicalNote"
                                        v-model="medicalNoteTemplateSelected"
                                    >
                                        <option
                                            v-for="option in medicalNoteTemplates"
                                            :value="option.id"
                                            :key="option.id"
                                            >{{ option.name }}
                                        </option>
                                    </select>
                                </div>
                                <div class="d-flex align-items-center mt-2">
                                    <i
                                        @click="onUpdateMedicalNote"
                                        class="fas fa-check btn-inline-edit"
                                        :class="{
                                            'disabled-link disabled': !isAbleUpdateMedicalNote
                                        }"
                                    />
                                    <i
                                        @click="editMedicalNote(false)"
                                        class="fas fa-times btn-inline-edit"
                                    />
                                </div>
                            </div>
                            <div
                                v-if="
                                    !isSelectingNoMedicalNote &&
                                    isCurrentMedicalNoteHasDocument
                                "
                                class="d-flex align-items-start mt-1"
                            >
                                <input
                                    type="checkbox"
                                    id="move-medical-note-document"
                                    class="mr-1 mt-1"
                                    v-model="moveMedicalNoteDocument"
                                />
                                <label
                                    for="move-medical-note-document"
                                    class="font-weight-normal m-0 font-italic checkbox-label"
                                    >Move records &amp; documents to the new
                                    Medical Note</label
                                >
                            </div>
                        </div>
                        <div v-else>
                            <span
                                v-if="currentMedicalNote"
                                v-html="getAppointmentSoap(currentMedicalNote)"
                            ></span>
                            <span v-else>No Medical Note</span>
                            <i
                                v-if="isAbleEditMedicalNote"
                                @click="editMedicalNote"
                                class="fas fa-pen btn-inline-edit secondary"
                            />
                        </div>
                    </div>
                </div>
            </div>
            <div
                v-if="data.active_webforms && data.active_webforms.length > 0"
                class="form-group row"
            >
                <label class="col-sm-3 col-form-label">Forms:</label>
                <div class="col-sm col-form-label">
                    <div v-for="(webform, i) in data.active_webforms" :key="i">
                        <WebformLink
                            v-if="webform"
                            router-name="client_webform"
                            :webform="webform"
                            :withIcon="true"
                        />
                    </div>
                </div>
            </div>
            <div
                v-if="
                    data.invoice ||
                    data.estimate ||
                    _.get(currentMedicalNote, 'invoices', []).length
                "
                class="form-group row"
            >
                <label class="col-sm-3 col-form-label">Billing:</label>
                <div class="col-sm-9 invoices-list">
                    <template
                        v-if="_.get(currentMedicalNote, 'invoices', []).length"
                    >
                        <p
                            v-for="bill in _.get(
                                currentMedicalNote,
                                'invoices'
                            )"
                            :key="bill.id"
                        >
                            <!-- Check if it is estimate -->
                            <estimate-link
                                v-if="bill.is_estimate"
                                :estimate="bill"
                                :text="bill.label"
                            />
                            <InvoiceLink
                                v-else
                                :invoice="bill"
                                :text="bill.label"
                                :newTab="false"
                            />
                        </p>
                    </template>
                    <p v-else-if="data.invoice">
                        <InvoiceLink
                            :invoice="data.invoice"
                            :text="data.invoice.label"
                            :newTab="false"
                        />
                    </p>
                    <p v-else-if="data.estimate">
                        <estimate-link
                            :estimate="data.estimate"
                            :text="data.estimate.label"
                            :useRouter="USE_ESTIMATE_MODULE_VUE"
                        />
                    </p>
                </div>
            </div>
        </form>

        <summarize
            v-if="summarizer.isOpen"
            :patientId="summarizer.patientId"
            @close="summarizer.isOpen = false"
        />
    </div>
</template>
<style lang="scss" scoped>
.invoices-list p {
    padding: 0px;
    padding-top: 0.375rem;
    margin: 0px;
}
.patient-row {
    display: flex;
    align-items: center;
    gap: 7px;
}
</style>
<script>
import EstimateLink from "@/components/commons/estimate-link";
import ScheduleHelper from "@/module/schedule/helper";
import TriageService from "@/services/triage";
import TemplateService from "@/services/templates";
import ScheduleService from "@/services/schedule";
import { includes, orderBy } from "lodash";
import CensusMixin from "@/mixins/census";
import SummarizeButton from "@/module/patient/summarize-button.vue";
import Summarize from "@/module/patient/summarize.vue";

const NO_MEDICAL_NOTE = "no-medical-note";
const NEW_MEDICAL_NOTE = "new-medical-note";

export default {
    name: "List",
    filters: {
        truncate: function (text, length, suffix) {
            if (text.length > length) {
                return text.substring(0, length) + suffix;
            } else {
                return text;
            }
        }
    },
    mixins: [ScheduleHelper, CensusMixin],
    components: {
        EstimateLink,
        WebformLink: () => import("@/components/commons/webform-link"),
        InvoiceLink: () => import("@/components/commons/invoice-link"),
        SummarizeButton,
        Summarize
    },
    props: {
        data: {
            type: Object,
            // Object or array defaults must be returned from
            // a factory function
            default: function () {
                return {};
            }
        },
        module: {
            type: String,
            default: null
        }
    },
    data() {
        return {
            USE_CLIENT_MODULE_VUE: process.env.USE_CLIENT_MODULE_VUE === "true",
            USE_PATIENT_MODULE_VUE:
                process.env.USE_PATIENT_MODULE_VUE === "true",
            isEditTriage: false,
            isLoadingTriage: false,
            triageSelected: null,
            triageOptions: [],
            isEditMedicalNote: false,
            isLoadingMedicalNote: false,
            currentMedicalNote: null,
            medicalNoteSelected: null,
            medicalNoteTemplateSelected: null,
            medicalNotes: [],
            medicalNoteTemplates: [],
            moveMedicalNoteDocument: true,
            summarizer: {
                isOpen: false,
                patientId: null
            },
            isSummarizerEnabled: false
        };
    },
    computed: {
        title() {
            return this.start
                ? moment(this.start).format("hh:mm a") +
                      " - " +
                      this.end.format("hh:mm a")
                : "";
        },
        start() {
            return moment(this.data.start);
        },
        end() {
            return moment(this.data.end);
        },
        statusAccess() {
            return (
                this._hasAccess("schedule.appointment.update") &&
                this.data.appointmentStatus &&
                !includes(
                    [
                        this.APPOINTMENT.STATUS_CHECKED_OUT,
                        this.APPOINTMENT.STATUS_REJECTED,
                        this.APPOINTMENT.STATUS_UNCONFIRMED_OL,
                        this.APPOINTMENT.STATUS_ADMITTED,
                        this.TREATMENT.CANCELLED,
                        this.TREATMENT.DISCHARGED,
                        this.TREATMENT.ADMITTED,
                        this.TREATMENT.PRETREATMENT,
                        this.TREATMENT.TREATMENT,
                        this.TREATMENT.POSTTREATMENT
                    ],
                    this.data.appointmentStatus.id
                )
            );
        },
        isRecurring() {
            return (
                this.data &&
                this.data.occurrence_id &&
                !_.isEmpty(this.data.occurrence_id)
            );
        },
        triageObjectDisplay: {
            get() {
                return this.data.active_triage;
            },
            set(newValue) {
                this.data.active_triage = newValue;
            }
        },
        medicalNoteOptions() {
            return [
                { id: NO_MEDICAL_NOTE, label: "No Medical Note" },
                { id: NEW_MEDICAL_NOTE, label: "New Medical Note" },
                ...this.medicalNotes
            ];
        },
        isSelectingNoMedicalNote() {
            return this.medicalNoteSelected === NO_MEDICAL_NOTE;
        },
        isSelectingNewMedicalNote() {
            if (!this.isEditMedicalNote) {
                return false;
            }

            return this.medicalNoteSelected === NEW_MEDICAL_NOTE;
        },
        isSelectingExistingMedicalNote() {
            return (
                !this.isSelectingNoMedicalNote &&
                !this.isSelectingNewMedicalNote
            );
        },
        isCurrentMedicalNoteHasDocument() {
            if (!this.currentMedicalNote) {
                return false;
            }

            return this.currentMedicalNote.hasDocument;
        },
        isAbleEditMedicalNote() {
            return (
                this.module === "modal" &&
                this._hasAccess("schedule.appointment.update") &&
                this.data.patient_id &&
                includes(
                    [
                        this.APPOINTMENT.STATUS_CHECKED_IN,
                        this.APPOINTMENT.STATUS_IN_ROOM,
                        this.APPOINTMENT.STATUS_VISIT_COMPLETE,
                        this.TREATMENT.ADMITTED,
                        this.TREATMENT.TREATMENT
                    ],
                    this.data.appointmentStatus.id
                )
            );
        },
        isAbleUpdateMedicalNote() {
            if (!this.currentMedicalNote) {
                return true;
            }

            return this.medicalNoteSelected !== this.currentMedicalNote.id;
        },
        canShowMedicalNoteField() {
            return (
                this.data.appointmentStatus &&
                !includes(
                    [
                        this.APPOINTMENT.STATUS_NOT_CONFIRMED,
                        this.APPOINTMENT.STATUS_CONFIRMED,
                        this.APPOINTMENT.STATUS_PREVISIT
                    ],
                    this.data.appointmentStatus.id
                )
            );
        }
    },
    mounted() {
        this.setCurrentMedicalNote(this.data.soap);
        this.checkSummarizerFeature();
    },
    watch: {
        "data.soap"(value) {
            this.setCurrentMedicalNote(value);
        }
    },
    methods: {
        checkSummarizerFeature() {
            setTimeout(() => {
                // $root.setting.feature_flag tidak peduli `is_enabled` dalam DB,
                // jadi semua yang ada akan tersenarai walaupun is_enabled 0 -- TODO / FIXME
                let flags = this.$root.setting?.feature_flag ?? "";
                let isEnabled = flags.split(",").includes("ai_patient_info");
                this.isSummarizerEnabled = isEnabled;
            }, 600);
        },
        openSummarizePatient() {
            this.summarizer = {
                isOpen: true,
                patientId: this.data.patient.id
            };
        },
        replaceNewLine(str = "") {
            if (str) {
                return str.replace(/\n/g, "<br/>");
            }

            return "";
        },
        getPatientBreed(data) {
            var patient_name = "";

            if (data.patient) {
                if (data.patientBreeds) {
                    patient_name += " (";

                    var i = 0;
                    data.patientBreeds.forEach(element => {
                        i++;

                        if (i == data.patientBreeds.length) {
                            patient_name +=
                                element.name +
                                " - " +
                                element.species_name.toLowerCase();
                        } else {
                            patient_name +=
                                element.name +
                                " - " +
                                element.species_name.toLowerCase() +
                                ", ";
                        }
                    });
                    patient_name += ")";
                }
            }

            return patient_name;
        },
        statusClick(event) {
            this.$emit("status", event, this.data);
            this.$root.$emit(`bv::hide::popover`);
        },
        getAppointmentLocation(data) {
            if (data.appointment_location) {
                if (data.appointmentLocation) {
                    if (
                        data.appointment_location.location_source ==
                        this.APPOINTMENT_SOURCE.SOURCE_COMPANY
                    ) {
                        return (
                            '<a href="' +
                            process.env.CI_APPS +
                            "contact/company/view/" +
                            data.appointmentLocation.encoded_id +
                            '" target="_blank">' +
                            data.appointmentLocation.name +
                            "</a>"
                        );
                    } else {
                        if (data.appointmentLocation.is_client) {
                            return (
                                '<a href="' +
                                process.env.CI_APPS +
                                "client/client/view/" +
                                data.appointmentLocation.encoded_id +
                                '" target="_blank">' +
                                data.appointmentLocation.label +
                                "</a>"
                            );
                        } else {
                            return (
                                '<a href="' +
                                process.env.CI_APPS +
                                "contact/contact/view/" +
                                data.appointmentLocation.encoded_id +
                                '" target="_blank">' +
                                data.appointmentLocation.label +
                                "</a>"
                            );
                        }
                    }
                }
            }

            return "In Clinic";
        },
        getAppointmentAddress(data) {
            if (data.appointment_location) {
                if (
                    data.appointmentLocation &&
                    data.appointmentLocation.address_label
                ) {
                    return (
                        '<a href="' +
                        data.appointmentLocation.google_map_direction.replace(
                            /#/g,
                            "%23"
                        ) +
                        '" target="_blank">' +
                        data.appointmentLocation.address_label +
                        "</a>"
                    );
                }
            }

            return "";
        },
        getAppointmentBilling(data) {
            var billing = "";

            if (data.invoice) {
                billing =
                    '<a href="' +
                    process.env.CI_APPS +
                    data.invoice.ci_url +
                    '">' +
                    data.invoice.label +
                    "</a>";
            } else if (data.estimate) {
                billing =
                    '<a href="' +
                    process.env.CI_APPS +
                    data.estimate.ci_url +
                    '">' +
                    data.estimate.label +
                    "</a>";
            }

            return billing;
        },
        getAppointmentSoap(data) {
            var soap = "";

            if (data) {
                if (data.isactive) {
                    soap =
                        '<a href="' +
                        process.env.CI_APPS +
                        data.ci_url +
                        '" target="_blank">' +
                        data.label +
                        "</a>";
                } else {
                    soap = data.label + " (inactive)";
                }
            }

            return soap;
        },
        getAssignTo(data) {
            if (data.is_staff == 1) {
                if (data.staff) {
                    if (data.staff.display_name) {
                        return data.staff.display_name;
                    } else {
                        return data.staff.label;
                    }
                }
            } else {
                if (data.nonStaff) {
                    if (data.nonStaff.display_name) {
                        return data.nonStaff.display_name;
                    }
                }
            }
        },
        async getTriageList() {
            await TriageService.getTriageTypeLists()
                .then(res => {
                    if (res && res.code === 200) {
                        this.triageSelected = this.data?.active_triage?.active_triage_type?.id;
                        this.triageOptions = res.resources;
                    } else {
                        throw new Error(
                            "Error: Unable to get the triage list."
                        );
                    }
                })
                .catch(e => {
                    console.error(e);
                    this._message(
                        "Error: Unable to get the triage list.",
                        "danger"
                    );
                })
                .finally(() => {
                    this.isLoadingTriage = false;
                    this.isEditTriage = true;
                });
        },
        editTriage() {
            this.isLoadingTriage = true;
            this.getTriageList();
        },
        async updateTriage() {
            this.isLoadingTriage = true;
            let params = {
                triage_type_id: this.triageSelected
            };

            await TriageService.updateTriageType(
                this.data?.active_triage?.id,
                params
            )
                .then(res => {
                    if (res && res.code === 200) {
                        this.triageObjectDisplay = res.resources;
                        this.$emit("updated", this.data?.id);
                    } else {
                        throw new Error(
                            "Error: Unable to save the triage list."
                        );
                    }
                })
                .catch(e => {
                    console.error(e);
                    this._message(
                        "Error: Unable to save triage type.",
                        "danger"
                    );
                })
                .finally(() => {
                    // Emit socket to refresh census
                    const payload = {
                        appointmentDate: this.data?.start.unix(),
                        appointmentId: this.data?.id,
                        instanceId: this.instanceId
                    };

                    this.refreshCensus(payload);
                    this.isLoadingTriage = false;
                    this.isEditTriage = false;
                });
        },
        setTriageStyle(triageObjectDisplay) {
            return {
                backgroundColor:
                    triageObjectDisplay.active_triage_type &&
                    triageObjectDisplay.active_triage_type.background_color_code
                        ? "#" +
                          triageObjectDisplay.active_triage_type
                              .background_color_code
                        : "",
                color:
                    triageObjectDisplay.active_triage_type &&
                    triageObjectDisplay.active_triage_type.text_color_code
                        ? "#" +
                          triageObjectDisplay.active_triage_type.text_color_code
                        : "",
                borderColor:
                    triageObjectDisplay.active_triage_type &&
                    triageObjectDisplay.active_triage_type.border_color_code
                        ? "#" +
                          triageObjectDisplay.active_triage_type
                              .border_color_code
                        : ""
            };
        },
        async editMedicalNote(isEdit = true) {
            this.isEditMedicalNote = isEdit;
            this.moveMedicalNoteDocument = true;

            if (!isEdit) {
                return;
            }

            this.isLoadingMedicalNote = true;

            // fetch exisiting medical note tied to the appointment
            await this.getExistingMedicalNotes();
            this.medicalNoteSelected = this.currentMedicalNote?.id
                ? this.currentMedicalNote.id
                : this.medicalNoteOptions[0].id;

            // fetch existing medical note template if create new medical note
            await this.getMedicalNoteTemplates();

            this.isLoadingMedicalNote = false;
        },

        onUpdateMedicalNote() {
            // ask for confirmation if the medical note has document
            if (
                !this.isSelectingNoMedicalNote &&
                this.isCurrentMedicalNoteHasDocument &&
                this.moveMedicalNoteDocument === true
            ) {
                this.$parent.$parent.$parent.$refs.modalConfirmationDialog.open();
                return;
            }

            this.updateMedicalNote();
        },
        async updateMedicalNote() {
            if (!this.data.patient_id || !this.isAbleUpdateMedicalNote) {
                return;
            }
            this.isLoadingMedicalNote = true;

            let isNewSoap;

            if (this.isSelectingNoMedicalNote) {
                isNewSoap = "no_soap";
            } else if (this.isSelectingNewMedicalNote) {
                isNewSoap = 1; // new soap
            } else {
                isNewSoap = 0; // existing soap
            }

            const payload = {
                is_new_soap: String(isNewSoap), //1 to create new soap, 0 to use existing soap, no_soap
                soap_id: this.isSelectingExistingMedicalNote
                    ? this.medicalNoteSelected
                    : null, //if use existing soap
                template_id: this.isSelectingNewMedicalNote
                    ? this.medicalNoteTemplateSelected
                    : null, //if create new soap
                move_record:
                    !this.isSelectingNoMedicalNote &&
                    this.isCurrentMedicalNoteHasDocument &&
                    this.moveMedicalNoteDocument
                        ? 1
                        : 0
            };

            try {
                const response = await ScheduleService.updateAppointmentMedicalNote(
                    this.data.id,
                    payload
                );

                if (response.code !== 200) {
                    throw new Error(response);
                }

                this.currentMedicalNote = response.resource;

                if (response.resource) {
                    this.currentMedicalNote.hasDocument =
                        response.resource.soap_data;
                }

                this.$emit("updated", this.data.id);

                this._message(response.message);
            } catch (error) {
                this._message("Failed to update medical note.", "error");
                console.error(error);
            } finally {
                this.isEditMedicalNote = false;
                this.isLoadingMedicalNote = false;
            }
        },
        async getMedicalNoteTemplates() {
            const { message, resources } = await TemplateService.getSoap();

            if (message.code != 200) {
                throw new Error("Unable to fetch medical note templates.");
            }

            this.medicalNoteTemplates = resources;
            this.medicalNoteTemplateSelected = this.medicalNoteTemplates[0].id;
        },
        async getExistingMedicalNotes() {
            try {
                let response = await ScheduleService.getMedicalNoteList(
                    this.data.id
                );
                if (response.message?.code !== 200) {
                    throw new Error("Unable to fetch medical notes.");
                }

                this.medicalNotes = response.resource?.data || [];

                this.medicalNotes = orderBy(
                    this.medicalNotes,
                    "date.date",
                    "desc"
                );
            } catch (error) {
                console.error(error);
                this._message("Unable to fetch medical notes.", "danger");
            }
        },
        setCurrentMedicalNote(medicalNote) {
            this.currentMedicalNote = medicalNote;

            if (medicalNote) {
                this.currentMedicalNote.hasDocument = this.data.soap_data;
            }
        }
    }
};
</script>

<style scoped>
.checkbox-label {
    padding-top: 0.05rem;
    font-size: 13.5px;
}
</style>
